import React,{useState,useEffect} from "react";
import { Grid } from "@mui/material";
import Slider from "@mui/material/Slider";
import styled from "styled-components";

const StyledGridItem = styled(Grid)`
  margin-bottom: 5px;
  text-align: left;
  font: normal normal 550 13px/18px Open Sans;
  color: black;
  opacity: 1;
`;

const StyledSliderWrapper = styled.div`
  text-align: left;
  margin: 5px 10px;
  width: 100%;
`;

const StyledSlider = styled(Slider)`
  & .MuiSlider-valueLabelCircle {
    font-size: 10px;
  }
`;

const CommonRangeSelectSlider = ({
  title = "",
  value = [0, 1],
  onChange,
  min = 0,
  max = 1,
  steps = 0.1,
}) => {

 // Set the values only when mouse is released
  const handleMouseUp = (event, newValue) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    let minValue, maxValue;
    minValue = Math.min(newValue[0], value[1] - steps);
    maxValue = Math.max(newValue[1], value[0] + steps);

    onChange(minValue,maxValue)
  };

  return (
    <>
      <StyledGridItem item xs={12} sm={12} md={12}>
        {title}
      </StyledGridItem>
      <StyledSliderWrapper>
        <StyledSlider
          getAriaLabel={() => "Minimum distance"}
          value={value}
          size="small"
          valueLabelDisplay="auto"
          onChangeCommitted={handleMouseUp}
          step={steps}
          min={min}
          max={max}
          marks={[
            { value: min, label: `${min}` },
            { value: max, label: `${max}` },
          ]}
        />
      </StyledSliderWrapper>
    </>
  );
};

export default CommonRangeSelectSlider;
